// lib
import {
  AYTM_LOGIC_STATEMENT_MATCH,
  AYTM_LOGIC_ESCAPE_BRACKET_MATCH
} from '@aytm/app/survey/editor/lib/logic/statements'

export default function countText(text = '') {
  return text
    .replace(AYTM_LOGIC_STATEMENT_MATCH, '')
    .replace(AYTM_LOGIC_ESCAPE_BRACKET_MATCH, match => match.slice(1, -1)).length
}
